import React from 'react';

import styled from 'styled-components';

import ColumnBuilder from './ColumnBuilder';














const Row = styled.div.attrs((props) => ({
  style: { ...props.style }
}))`
${(props) => props.computedStyle}`;

const Col = styled.div.attrs((props) => ({
  style: { ...props.style }
}))`${(props) => props.computedStyle}`;

const RowBuilder = (props) => {
  const { isVisible, uuid, columns, container } = props;

  if (!isVisible) {
    return null;
  }

  return (
    <Row
      key={uuid}
      style={{
        display: 'flex',
        ...container.style
      }}
      computedStyle={container.computedStyle}>

      {columns.map((column) =>
      <Col
        key={column.uuid}
        columnSize={column.columnSize}
        style={{ ...column?.container.style, flex: column.columnSize }}
        computedStyle={column?.container.computedStyle}>

          {column.modules.map((module) => <ColumnBuilder key={module.uuid} {...module} />)}
        </Col>
      )}
    </Row>);

};

export default RowBuilder;